export default {
  title: 'Dieses Restaurant kann noch nicht live gehen',
  description:
    'Ihr Partnerkonto hat keine Verarbeitungsgebühr für Online-Zahlungen und keine bestätigte Marge von 0 %. Stripe berechnet seine Gebühren Ihrer Plattform, daher muss zuerst eines von beidem festgelegt werden.',
  partner_action:
    'Legen Sie eine Standard-Verarbeitungsgebühr fest oder bestätigen Sie, dass Sie Ihren Restaurants keine berechnen und die Stripe-Gebühren selbst tragen.',
  ask_partner:
    'Ihr Partner hat seine Verarbeitungsgebühr für Online-Zahlungen noch nicht festgelegt. Danach kann dieses Restaurant live gehen.',
  buttons: {
    set_rate: 'Verarbeitungsgebühr festlegen',
    close: 'Schließen',
  },
};
